import TagManager from "@sooro-io/react-gtm-module";

export const initGTM = () => {
  const enabled = process.env.REACT_APP_GTM_ENABLED === "true";
  const gtmId = process.env.REACT_APP_GTM_ID;

  if (!enabled || !gtmId) return false;

  TagManager.initialize({ gtmId });
  return true;
};